<template>
  <header class="page-header">
    <h1 class="page-header__title -lighter">Découvrez les différents décors que nous avons fabriqué au courant des dernières années</h1>
    <p>Pour toute information supplémentaire, n’hésitez pas à <router-link :to="{ name: 'home', hash: '#contact' }" class="link -accent">nous contacter</router-link>.</p>
  </header>
</template>

<script>
export default {
  name: 'PortfolioHeader'
}
</script>
